import React, { Fragment } from 'react';
import { Outlet } from 'react-router';
import { Box, Container } from '@mui/material';
import { FirestoreUserRole } from 'generated/graphql';
import OperatorThemeProvider from '@/operator/OperatorThemeProvider';
import { AppContextProvider } from '@/operator/context/AppContext';
import AuthzGuard from './helpers/AuthzGuard';

type Props = {
    roles?: FirestoreUserRole[];
    secure?: boolean;
};

const OperatorLayout: React.FC<Props> = ({ secure = false }) => {
    const MaybeGuard = secure ? AuthzGuard : Fragment;

    return (
        <OperatorThemeProvider>
            <AppContextProvider>
                <MaybeGuard>
                    <Box display="flex">
                        <Container
                            maxWidth="xl"
                            component="main"
                            sx={{ flexGrow: 1, paddingTop: 3 }}
                        >
                            <Box sx={{ flexGrow: 1 }} marginBottom="64px">
                                <Outlet />
                            </Box>
                        </Container>
                    </Box>
                </MaybeGuard>
            </AppContextProvider>
        </OperatorThemeProvider>
    );
};

export default OperatorLayout;
